<template>
    <section class="plans flex-grow-1">
        <div class="titlelayoutLayout1" v-if="hasReady" style="display: flex">
            <TitlePage
                title="Planos"
                subtitle="Crie e personalize um plano mensal, trimestral, semestral ou anual e defina descontos no pagamento à vista"
                :hasMargin="true"
                class="p-4 p-md-1"
            />
            <v-btn
                variant="outlined"
                color="primary"
                rounded="2"
                border="2"
                :size="$vuetify.display.xs ? 'small' : 'large'"
                :icon="$vuetify.display.xs"
                class="text-none btnNew"
                @click="openNewPlanModal"
            >
                <template v-if="$vuetify.display.xs">
                    <v-icon>mdi-plus</v-icon>
                </template>
                <template v-else>
                    <v-icon start>mdi-plus</v-icon>
                    Novo Plano
                </template>
            </v-btn>
        </div>
        <div class="plan" v-if="hasReady">
            <div class="itens">
                <div
                    class="item myPlanWeflixStyle"
                    v-for="plan in plans"
                    :key="plan.id"
                >
                    <div class="infoItemPlan">
                        <div class="title planName">
                            <h3>{{ plan.name }}</h3>
                            <span>R$ {{ formatarNumero(plan.planValue) }}</span>
                        </div>
                        <div class="description">
                            <p>
                                Cobrança
                                <span v-if="plan.planType == 1">Mensal</span>
                                <span v-if="plan.planType == 2">Semestral</span>
                                <span v-if="plan.planType == 3"
                                    >Trimestral</span
                                >
                                <span v-if="plan.planType == 4">Anual</span>
                            </p>
                            <span><fa icon="fa-credit-card" /></span>
                            <!-- <span v-if="plan.billet == 1"><fa icon="fa-barcode" /></span>
                        <span v-if="plan.pix == 1">
                            <svg style="width: 15px;" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                                <path d="M242.4 292.5C247.8 287.1 257.1 287.1 262.5 292.5L339.5 369.5C353.7 383.7 372.6 391.5 392.6 391.5H407.7L310.6 488.6C280.3 518.1 231.1 518.1 200.8 488.6L103.3 391.2H112.6C132.6 391.2 151.5 383.4 165.7 369.2L242.4 292.5zM262.5 218.9C256.1 224.4 247.9 224.5 242.4 218.9L165.7 142.2C151.5 127.1 132.6 120.2 112.6 120.2H103.3L200.7 22.8C231.1-7.6 280.3-7.6 310.6 22.8L407.8 119.9H392.6C372.6 119.9 353.7 127.7 339.5 141.9L262.5 218.9zM112.6 142.7C126.4 142.7 139.1 148.3 149.7 158.1L226.4 234.8C233.6 241.1 243 245.6 252.5 245.6C261.9 245.6 271.3 241.1 278.5 234.8L355.5 157.8C365.3 148.1 378.8 142.5 392.6 142.5H430.3L488.6 200.8C518.9 231.1 518.9 280.3 488.6 310.6L430.3 368.9H392.6C378.8 368.9 365.3 363.3 355.5 353.5L278.5 276.5C264.6 262.6 240.3 262.6 226.4 276.6L149.7 353.2C139.1 363 126.4 368.6 112.6 368.6H80.8L22.8 310.6C-7.6 280.3-7.6 231.1 22.8 200.8L80.8 142.7H112.6z"/>
                            </svg>
                        </span>  -->
                        </div>
                    </div>
                    <div class="actionsItem">
                        <button
                            class="btnIcon"
                            @click="openEditPlanModal(plan)"
                        >
                            <fa icon="fa-pencil" />
                        </button>
                        <button
                            class="btnIcon"
                            @click="openDeleteDialog(plan)"
                        >
                            <fa icon="fa-trash" />
                        </button>
                        <!-- <button class="btnIcon" :class="{ active: i === 1 }"><fa icon="fa-star" /></button> -->
                    </div>
                </div>
            </div>
        </div>
        <div class="titlelayoutLayout seondary mt-0 pa-5" v-if="hasReady">
            <div
                class="mb-1 mb-md-3 d-flex align-center justify-space-between justify-sm-start"
            >
                <div
                    class="d-flex align-center mr-6 mr-md-10"
                    style="min-width: 144px"
                >
                    <h3 class="mb-0 mr-2">Trial</h3>
                    <v-chip
                        variant="elevated"
                        :color="statusTrial === 'Ativado' ? 'green' : 'default'"
                        density="comfortable"
                        size="small"
                    >
                        {{ statusTrial }}
                    </v-chip>
                </div>
                <CustomToggle
                    v-model="isTrialActive"
                    @change="changeStatusTrial"
                />
            </div>
            <small
                >Defina um período de teste grátis para seus novos
                assinantes.</small
            >
        </div>
        <div class="trial" v-if="isTrialActive && hasReady">
            <p>
                Seus assinantes poderão experimentar seu conteúdo por
                <strong style="color: #250891">{{ trialRange[1] }} dias</strong>
                gratuitamente..
            </p>
            <v-card class="cardTrial">
                <v-card-text>
                    <v-range-slider
                        v-model="trialRange"
                        :min="3"
                        :max="30"
                        :step="1"
                        thumb-label="always"
                        strict
                    >
                        <template v-slot:thumb-label="{ modelValue }">
                            {{ modelValue }}
                        </template>
                    </v-range-slider>
                </v-card-text>
            </v-card>
            <div class="px-4">
                <p class="warning">
                    <strong>Atenção:</strong> Alterar o período de teste afetará
                    apenas novos assinantes.
                </p>
            </div>
        </div>
    </section>
    <div class="pa-4 pa-md-5 mt-3 mt-md-6 d-flex justify-center justify-md-end">
        <v-btn variant="outlined" border="2" color="primary" size="large" width="140" @click="editTrial">
            Salvar
        </v-btn>
    </div>
    <Loader :hasReady="hasReady" />
    
    <v-dialog
        v-model="isNewPlanModalOpen"
        max-width="720"
        scrollable
        :persistent="newPlanFormSaving"
    >
        <v-card class="new-plan-modal-card">
            <v-card-title
                class="d-flex align-center justify-space-between text-wrap pr-2"
            >
                <span class="text-h6 font-weight-bold">Novo Plano</span>
                <v-btn
                    icon
                    variant="text"
                    density="comfortable"
                    :disabled="newPlanFormSaving"
                    aria-label="Fechar"
                    @click="closeNewPlanModal"
                >
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-card-title>
            <v-card-subtitle class="text-wrap pb-0">
                Escolha um nome e uma periodicidade de renovação de assinatura
                para este plano.
            </v-card-subtitle>
            <v-divider class="mt-4" />
            <v-card-text class="pa-4 pa-md-6">
                <NewPlanForm
                    ref="newPlanFormRef"
                    layout="modal"
                    hide-heading
                    @saving-change="newPlanFormSaving = $event"
                    @success="onNewPlanSuccess"
                    @cancel="closeNewPlanModal"
                />
            </v-card-text>
        </v-card>
    </v-dialog>

    <v-dialog
        v-model="isEditPlanModalOpen"
        max-width="720"
        scrollable
        :persistent="editPlanFormSaving"
    >
        <v-card v-if="editingPlanId" class="new-plan-modal-card">
            <v-card-title
                class="d-flex align-center justify-space-between text-wrap pr-2"
            >
                <span class="text-h6 font-weight-bold">Editar Plano</span>
                <v-btn
                    icon
                    variant="text"
                    density="comfortable"
                    :disabled="editPlanFormSaving"
                    aria-label="Fechar"
                    @click="closeEditPlanModal"
                >
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-card-title>
            <v-card-subtitle class="text-wrap pb-0">
                Escolha um nome e uma periodicidade de renovação de assinatura
                para este plano.
            </v-card-subtitle>
            <v-divider class="mt-4" />
            <v-card-text class="pa-4 pa-md-6">
                <EditPlanForm
                    :key="editingPlanId"
                    :plan-id="editingPlanId"
                    layout="modal"
                    hide-heading
                    @saving-change="editPlanFormSaving = $event"
                    @success="onEditPlanSuccess"
                    @cancel="closeEditPlanModal"
                />
            </v-card-text>
        </v-card>
    </v-dialog>

    <v-dialog v-model="isDeleteDialogVisible" :max-width="600">
        <v-card class="modal-card">
            <v-card-title>
                <h3 class="mb-0">
                    Você tem certeza que deseja excluir esse plano?
                </h3>
            </v-card-title>
            <v-card-subtitle>
                Esta ação não poderá ser desfeita.
            </v-card-subtitle>
            <v-card-text>
                <p class="mb-1">
                    Nome: <strong>{{ planToDelete?.name }}</strong>
                </p>
                <p class="mb-1">
                    Valor: <strong>R$ {{ planToDelete ? formatarNumero(planToDelete.planValue) : '' }}</strong>
                </p>
            </v-card-text>
            <v-card-actions>
                <v-btn
                    class="flex-grow-1 cancel-btn"
                    color="grey-darken-4"
                    variant="tonal"
                    @click="isDeleteDialogVisible = false"
                    >Cancelar</v-btn
                >
                <v-btn
                    class="flex-grow-1 text-white"
                    color="danger"
                    variant="flat"
                    :loading="isDeleting"
                    :disabled="isDeleting"
                    @click="confirmDelete"
                    >Excluir</v-btn
                >
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>
<script>
    import Plan from '@/utils/Weflix/plan';
    import { mapState } from 'vuex';
    import { toast } from 'vue3-toastify';
    import Loader from '@/components/Weflix/Loader';
    import TitlePage from '@/components/Weflix/titlePage.vue';
    import CustomToggle from '@/components/Form/CustomToggle.vue';
    import NewPlanForm from '@/components/Weflix/Payment/NewPlanForm.vue';
    import EditPlanForm from '@/components/Weflix/Payment/EditPlanForm.vue';

    export default {
        components: {
            Loader,
            TitlePage,
            CustomToggle,
            NewPlanForm,
            EditPlanForm,
        },
        data() {
            return {
                statusTrial: 'Desativado',
                isTrialActive: false,
                trialRange: [3, 3],
                modelValue: 0,
                plans: [],
                hasReady: false,
                windowWidth: window.innerWidth,
                isMobileIcon: window.innerWidth < 600,
                isDeleteDialogVisible: false,
                planToDelete: null,
                isDeleting: false,
                isNewPlanModalOpen: false,
                newPlanFormSaving: false,
                isEditPlanModalOpen: false,
                editingPlanId: null,
                editPlanFormSaving: false,
            };
        },
        mounted() {
            window.addEventListener('resize', this.handleResize);
        },
        beforeDestroy() {
            window.removeEventListener('resize', this.handleResize);
        },
        computed: {
            ...mapState(['token']),
        },
        methods: {
            openNewPlanModal() {
                this.isNewPlanModalOpen = true;
                this.$nextTick(() => {
                    this.$refs.newPlanFormRef?.resetForm?.();
                });
            },
            closeNewPlanModal() {
                if (this.newPlanFormSaving) return;
                this.isNewPlanModalOpen = false;
            },
            async onNewPlanSuccess() {
                this.isNewPlanModalOpen = false;
                await this.getPlans();
                this.notify('Plano criado com sucesso!', 'success');
                this.$nextTick(() => {
                    this.$refs.newPlanFormRef?.resetForm?.();
                });
            },
            openEditPlanModal(plan) {
                this.editingPlanId = plan.id;
                this.isEditPlanModalOpen = true;
            },
            closeEditPlanModal() {
                if (this.editPlanFormSaving) return;
                this.isEditPlanModalOpen = false;
                this.$nextTick(() => {
                    this.editingPlanId = null;
                });
            },
            async onEditPlanSuccess() {
                this.isEditPlanModalOpen = false;
                this.$nextTick(() => {
                    this.editingPlanId = null;
                });
                await this.getPlans();
                this.notify('Plano atualizado com sucesso!', 'success');
            },
            changeStatusTrial() {
                this.statusTrial = this.isTrialActive
                    ? 'Ativado'
                    : 'Desativado';
            },
            async getPlans() {
                try {
                    const response = await Plan.getPlans(this.token);
                    this.hasReady = true;
                    this.plans = response;
                } catch (error) {
                    console.error(error);
                }
            },
            formatarNumero(numero) {
                let number = parseFloat(numero).toFixed(2);
                return number.replace('.', ',');
            },
            async editTrial() {
                this.hasReady = false;
                const payload = {
                    testPlan:
                        this.isTrialActive == false ? 0 : this.trialRange[1],
                };
                console.debug(payload, this.isTrialActive);
                try {
                    const response = await Plan.editTrial(payload, this.token);
                    this.hasReady = true;
                } catch (error) {
                    console.error(error);
                }
            },
            async getTrial() {
                try {
                    const response = await Plan.getTrial(this.token);
                    this.trialRange[1] = response;
                    if (this.trialRange[1] <= 3) {
                        this.isTrialActive = false;
                        this.changeStatusTrial();
                    } else {
                        this.isTrialActive = true;
                        this.changeStatusTrial();
                    }
                } catch (error) {
                    console.error(error);
                }
            },
            openDeleteDialog(plan) {
                this.planToDelete = plan;
                this.isDeleteDialogVisible = true;
            },
            async confirmDelete() {
                if (!this.planToDelete) return;
                
                this.isDeleting = true;
                try {
                    await Plan.deletePlan(this.token, this.planToDelete.id);
                    this.isDeleteDialogVisible = false;
                    this.planToDelete = null;
                    // Recarrega a lista de planos
                    await this.getPlans();
                    this.notify('Plano excluído com sucesso!', 'success');
                } catch (error) {
                    console.error('Erro ao deletar plano:', error);
                    this.notify('Erro ao excluir plano. Tente novamente.', 'error');
                } finally {
                    this.isDeleting = false;
                }
            },
            notify(message, type = 'info') {
                toast(message, {
                    autoClose: 3000,
                    position: 'top-right',
                    theme: 'light',
                    limit: 1,
                    type: type,
                    dangerouslyHTMLString: true,
                });
            },
        },
        created() {
            this.getPlans();
            this.getTrial();
        },
        handleResize() {
            this.windowWidth = window.innerWidth;
        },
    };
</script>

<style scoped>
    .plans {
        position: relative;
    }
    button.btnNew {
        position: absolute;
        top: 20px;
        right: 20px;
    }

    .titlelayoutLayout {
        text-align: left;
        padding: 10px;
        border-bottom: 1px solid #e3e3e3;
        margin-bottom: 10px;
    }
    .item {
        background-color: #eef0f5;
        padding: 9px 20px;
        border-radius: 5px;
        flex-direction: row;
        width: 100%;
    }
    .item.myPlanWeflixStyle {
        display: flex;
        justify-content: space-between;
    }
    .title {
        display: flex;
        justify-content: left;
        gap: 10px;
        align-items: center;
    }
    .description {
        display: flex;
        gap: 5px;
        align-items: center;
    }

    .description p {
        margin: 0;
    }
    .itens {
        display: flex;
        flex-wrap: wrap;
        gap: 10px;
    }
    .title h3 {
        margin: 0;
        font-weight: 600;
    }
    .actionsItem {
        display: flex;
        align-items: center;
        gap: 35px;
    }
    .title span {
        font-size: 13px;
        font-weight: 200;
        color: gray;
        line-height: 15px;
    }
    .description p {
        margin: 0;
        font-size: 15px;
        color: #707173;
    }
    .description span svg {
        font-size: 15px;
        color: black !important;
    }
    .description span svg path {
        fill: black !important;
    }
    .titlelayoutLayout.seondary {
        margin-top: 20px;
        position: relative;
    }
    .itemAtionCollections.form-check.form-switch.paymentPlan {
        display: flex;
        gap: 10px;
        align-items: center;
        justify-content: flex-start;
        padding-left: 0;
    }
</style>
<style scoped>
    .description span svg path {
        fill: #535353 !important;
    }
    .itemAtionCollections .form-check-input {
        margin-right: 1rem !important;
        cursor: pointer;
        flex-shrink: 0;
        width: 3rem;
        height: 1rem;
        background-color: #d7d7d7;
        border: 1px solid #8d8d8d;
        box-shadow: none;
    }
    .v-slider-track__fill {
        background-color: rgb(37 8 145) !important;
    }
    .v-slider-thumb__surface.elevation-2 {
        background-color: #160266 !important;
    }
    .v-slider-thumb__label {
        background-color: #250891 !important;
    }
    .cardTrial.v-card.v-theme--light.v-card--density-default.v-card--variant-elevated {
        padding: 15px 30px !important;
        box-shadow: none !important;
    }
    button.btnIcon.active svg path {
        fill: #e5c519 !important;
    }

    .warning {
        text-align: left;
        background-color: #f6f6f6;
        border-radius: 5px;
        border: 1px solid #e7e7e7;
        margin: 10px auto;
    }
    @media (max-width: 600px) {
        button.btnNew {
            right: 12px;
        }
        .warning {
            width: 100%;
        }
        .cardTrial.v-card.v-theme--light.v-card--density-default.v-card--variant-elevated {
            padding: 15px 0px !important;
        }
        .itemAtionCollections.form-check.form-switch.paymentPlan {
            position: absolute;
            top: -10px;
            right: -50px;
            display: flex;
            gap: 10px;
            align-items: center;
        }
    }

    .plan {
        padding: 20px;
    }
    .v-card.v-theme--light.v-card--density-default.v-card--variant-elevated.cardTrial {
        background-color: #ffffff !important;
        color: white !important;
        padding: 15px 30px !important;
        box-shadow: none;
    }
    .title.planName {
        margin: 0;
        color: black;
    }
</style>
